import React from 'react';

import Screens from './screens';

import NotFound   from '../../../NotFound';
import SubSubTabs from '../../../../components/SubSubTabsList';

import { ITopMenuItem                         } from '../../../../types/common.interface';
import { WITHDRAWAL_TYPES                     } from '../../../../values/subTabs';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';


const OnlineTransaction: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const navigate = useNavigate();
  const currentMenu = window.location.pathname.split("/")[5];
  const [selectedTab, setSelectedTab] = React.useState<ITopMenuItem>(
    WITHDRAWAL_TYPES.find((item) => item.pathname === currentMenu) as ITopMenuItem
  );

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onTabClick(tab: any): void {
    navigate(tab.pathname);
    setSelectedTab(tab);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  React.useEffect((): void => {
    setSelectedTab(WITHDRAWAL_TYPES.find((item) => item.pathname === currentMenu) as ITopMenuItem);
  }, [currentMenu]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <>
      <SubSubTabs tabs={WITHDRAWAL_TYPES} onClick={onTabClick} selected={selectedTab as ITopMenuItem}/>
      <Routes>
        <Route path='/'        element={<Navigate to={'admin'}              />} />
        <Route path='/admin'   element={<Screens.AdminWithdrawalContainer   />} />
        <Route path='/driver'  element={<Screens.DriverWithdrawalContainer  />} />
        <Route path='/company' element={<Screens.CompanyWithdrawalContainer />} />
        <Route path='/*'       element={<NotFound                           />} />
      </Routes>
    </>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default OnlineTransaction;
